<template>
  <div class="content-wrapper">
    <!-- <layout></layout> -->
    <crumbs :trails="trails"></crumbs>
    <div class="withdraw-checking">
      <div class="filter-search">
        <el-form :inline="true" :rules="rules" :model="searchData" ref="searchForm">
          <el-form-item label="媒体商ID：" prop="userId">
            <el-input onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode || event.which))) || event.which === 8" maxlength="9" type="text" size="small" v-model.number="searchData.userId" clearable placeholder="请输入媒体商ID"></el-input>
          </el-form-item>
          <el-form-item label="公司名称：">
            <el-input size="small" v-model="searchData.companyName" clearable placeholder="请输入公司名称"></el-input>
          </el-form-item>
          <el-form-item label="审核状态：">
            <el-select size="small" v-model="searchData.status" placeholder="请选择">
              <el-option label="全部" value="-1"></el-option>
              <el-option label="审核中" value="1"></el-option>
              <el-option label="开票中" value="2"></el-option>
              <el-option label="待打款" value="3"></el-option>
              <el-option label="已打款" value="4"></el-option>
              <el-option label="已驳回" value="5"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="媒体运营：">
            <el-select size="small" v-model="searchData.sourceOperatorId" placeholder="请选择">
              <el-option label="全部" value=""></el-option>
              <template v-for="item in  SourceOperatorUserList">
                <el-option :label="item.UserName" :value="item.UserId" :key="item.UserId"></el-option>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item label="媒介：">
            <el-select size="small" v-model="searchData.SourcemanId" placeholder="请选择">
              <el-option label="全部" value=""></el-option>
              <template v-for="item in SourceUserList">
                <el-option :label="item.UserName" :value="item.UserId" :key="item.UserId"></el-option>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item label="申请日期：">
            <el-date-picker size="small" v-model="searchData.applyTime" value-format="yyyy-MM-dd" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="操作日期：">
            <el-date-picker size="small" v-model="searchData.operateTime" value-format="yyyy-MM-dd" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item style="margin-left: 150px;">
            <el-button type="primary" size="small" @click="getMediaWithdraw(1)">查询</el-button>
            <el-button type="primary" size="small" @click="confirmBatch" :disabled="!batchData.length">批量通过</el-button>
            <a class="export-button" :disabled="!ExportMeidaDrawData" :href="exportUrl" target="_blank">导出数据</a>
            <!-- <div class="import-button">
              <el-button type="primary" size="small" :disabled=" ! ImportMediaDrawData">
                导入数据
              </el-button>
              <input type="file" ref="uploadFile" :disabled="! ImportMediaDrawData" @change="previewImportData" class="import-file">
            </div> -->
          </el-form-item>
        </el-form>
      </div>
      <div class="sum-type">
        <span>结算金额：{{totalPretaxAmount}}</span>
        <span>税后金额：{{totalAftertaxAmount}}</span>
        <span>发票金额：{{totalInvoiceAmount}}</span>
      </div>
      <div class="data-type">
        <span class="el-icon-menu data-size">审核数据（{{dataSize}}）</span>
        <!-- <el-button type="primary">媒体结算</el-button> -->
        <!-- <el-button type="default" @click="changeType">财务添加</el-button> -->
      </div>
      <!-- 数据列表 -->
      <div class="data-list">
        <el-table :data="tableData" @selection-change="handleSelectionChange" stripe header-row-class-name="table-header-style" style="width: 100%">
          <el-table-column type="selection" width="55" :selectable="selectable">
          </el-table-column>
          <el-table-column align="center" fixed="left" label="审核操作" width="100">
            <template slot-scope="scope">
              <div v-if="Review > scope.row.Status">
                <el-tooltip content="未添加发票信息" :disabled="scope.row.InvoiceAmount? true : false" placement="top">
                  <span>
                    <el-button @click="resolveCheck(scope.row)" :disabled=" !scope.row.InvoiceAmount" type="text" size="small">通过</el-button>
                  </span>
                </el-tooltip>
                <el-button @click="rejectCheck(scope.row)" type="text" size="small">驳回</el-button>
              </div>
              <el-button type="text" size="small" v-else @click="jumpBill(scope.row, 2)">查看进度</el-button>
            </template>
          </el-table-column>
          <el-table-column align="center" fixed="left" label="发票操作" width="100">
            <template slot-scope="scope">
              <el-button type="text" @click="jumpBill(scope.row, 1)" :disabled=" !AddSourceInvoice" size="small" v-if=" !scope.row.InvoiceAmount && (scope.row.Status === 1 || scope.row.Status === 2 || scope.row.Status === 3)">
                添加发票
              </el-button>
              <el-button type="text" @click="jumpBill(scope.row, 0)" size="small" v-else>
                发票详情
              </el-button>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="AddDate" :formatter="formatDater" label="申请时间" min-width="110">
          </el-table-column>
          <el-table-column align="center" prop="OrderNumber" label="订单ID" min-width="250">
          </el-table-column>
          <el-table-column align="center" show-overflow-tooltip prop="UserId" label="媒体商ID" min-width="150">
          </el-table-column>
          <el-table-column align="center" show-overflow-tooltip prop="MediaName" label="媒体商姓名" min-width="150">
          </el-table-column>
          <el-table-column align="center" show-overflow-tooltip prop="CompanyName" label="公司名称" min-width="200">
          </el-table-column>
          <el-table-column align="center" show-overflow-tooltip prop="SourceOperator" label="媒体运营" min-width="150">
          </el-table-column>
          <el-table-column align="center" show-overflow-tooltip prop="Medium" label="媒介" min-width="150">
          </el-table-column>
          <el-table-column align="center" show-overflow-tooltip prop="ContractCompany" label="合同公司" min-width="200">
          </el-table-column>
          <el-table-column align="center" show-overflow-tooltip prop="PretaxAmount" label="结算金额" min-width="150">
          </el-table-column>
          <el-table-column align="center" show-overflow-tooltip prop="AftertaxAmount" :formatter="formatAftertaxAmount" label="税后金额" min-width="150">
          </el-table-column>
          <el-table-column align="center" show-overflow-tooltip prop="InvoiceAmount" label="发票金额" min-width="150">
          </el-table-column>
          <el-table-column align="center" show-overflow-tooltip prop="StatusStr" label="状态" min-width="150">
          </el-table-column>
          <el-table-column align="center" show-overflow-tooltip prop="BankUserName" label="打款户名" min-width="200">
          </el-table-column>
          <el-table-column align="center" prop="BankAccount" label="打款账号" min-width="250">
          </el-table-column>
          <el-table-column align="center" show-overflow-tooltip prop="BranchBankInfo" label="支行信息" min-width="200">
          </el-table-column>
          <el-table-column align="center" prop="UpdateDate" :formatter="formatDater" label="操作时间" min-width="110">
          </el-table-column>
          <el-table-column align="center" show-overflow-tooltip prop="AuditNote" label="备注" width="180">
          </el-table-column>
        </el-table>
        <!-- 分页显示 -->
        <el-pagination background layout="prev, pager, next" :total="dataSize" :page-size="20" :current-page="currentPage" @current-change="pageChange">
        </el-pagination>
      </div>
    </div>
    <!-- 弹层设置 -->
    <withdrawDialog :isShowdialog="isShowDiaLog" @close='closeDialog' :dialogPragram="dialogPragram"></withdrawDialog>
    <previewPrepaid :isShowPreview="isShowPreview" @close='closePreview' :dialogPragram="dialogPragram"></previewPrepaid>
  </div>
</template>

<script type="text/ecmascript-6">
Date.prototype.Format = function(fmt) {
  //author: meizz
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "h+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    S: this.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(
      RegExp.$1,
      (this.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
  return fmt;
};
// 面包屑
import crumbs from "../public/crumbs/newCrumbs";
import withdrawDialog from "../public/import-preview/confirm-withdraw-dialog";
import previewPrepaid from "../public/import-preview/preview-Prepaid-dialog";
// 工具函数
import { formatDateAll } from "common/js/common";
import XLSX from "xlsx";
// api
import {
  getMediaDrawPageList,
  exportMeidaDrawData,
  ReviewMediaDraw,
  getSourceOperatorUserList,
  getSourceUserList,
  getMediaList,
  ImportMediaDrawData,
  BatchReviewMediaDraw
} from "api/mediaWithdraw";

export default {
  data() {
    var validateUserId = (rule, value, callback) => {
      if (value != "") {
        if (/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/.test(value) == false) {
          callback(new Error("请填写数字！"));
        } else if (value > 999999999) {
          callback(new Error("输入不能超过9个字符"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      searchData: {
        userId: "",
        status: "-1",
        companyName: "",
        sourceOperatorId: "",
        SourcemanId: "",
        applyTime: "",
        operateTime: ""
      },
      rules: {
        userId: [{ validator: validateUserId, trigger: "change" }]
      },
      trails: [
        {
          trail: "财务管理",
          href: ""
        },
        {
          trail: "媒体提现审核",
          href: ""
        }
      ],
      dataSize: 0,
      isShowDiaLog: false,
      isShowPreview: false,
      currentPage: 1,
      totalPretaxAmount: 0,
      totalAftertaxAmount: 0,
      totalInvoiceAmount: 0,
      SourceOperatorUserList: [],
      SourceUserList: [],
      dialogPragram: {
        title: "提示",
        info: {},
        remark: false,
        type: "",
        callback: null,
        tableData: []
      },
      tableData: [],
      batchData: []
    };
  },
  computed: {
    exportUrl() {
      var filterData = {
        userId: this.searchData.userId,
        companyName: this.searchData.companyName,
        sourceOperatorId: this.searchData.sourceOperatorId,
        SourcemanId: this.searchData.SourcemanId,
        status: this.searchData.status - 0,
        BeginDate: this.searchData.applyTime
          ? this.searchData.applyTime[0]
          : "",
        EndDate: this.searchData.applyTime ? this.searchData.applyTime[1] : "",
        BeginUpdateDate: this.searchData.operateTime
          ? this.searchData.operateTime[0]
          : "",
        EndUpdateDate: this.searchData.operateTime
          ? this.searchData.operateTime[1]
          : ""
      };
      var url = `/IAD_MediaDraw/ExportMeidaDrawData?_t=${new Date().getTime()}`;
      for (var key in filterData) {
        url += `&${key}=${filterData[key] ? filterData[key] : ""}`;
      }
      return url;
    },
    Review() {
      if (this.$store.state.authorization.IAD_MediaDraw.PageFuncs.PayReview) {
        return 4;
      } else if (
        this.$store.state.authorization.IAD_MediaDraw.PageFuncs.InvoicingReview
      ) {
        return 3;
      } else if (
        this.$store.state.authorization.IAD_MediaDraw.PageFuncs.UnderReview
      ) {
        return 2;
      } else {
        return false;
      }
    },
    AddSourceInvoice() {
      if (this.$store.state.authorization.IAD_MediaDraw) {
        if (this.$store.state.authorization.IAD_MediaDraw.PageFuncs) {
          return this.$store.state.authorization.IAD_MediaDraw.PageFuncs
            .AddSourceInvoice;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    GetMediaDrawInfo() {
      if (this.$store.state.authorization.IAD_MediaDraw) {
        if (this.$store.state.authorization.IAD_MediaDraw.PageFuncs) {
          return this.$store.state.authorization.IAD_MediaDraw.PageFuncs
            .GetMediaDrawInfo;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    ExportMeidaDrawData() {
      if (this.$store.state.authorization.IAD_MediaDraw) {
        if (this.$store.state.authorization.IAD_MediaDraw.PageFuncs) {
          return this.$store.state.authorization.IAD_MediaDraw.PageFuncs
            .ExportMeidaDrawData;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    ImportMediaDrawData() {
      if (this.$store.state.authorization.IAD_MediaDraw) {
        if (this.$store.state.authorization.IAD_MediaDraw.PageFuncs) {
          return this.$store.state.authorization.IAD_MediaDraw.PageFuncs
            .ImportMediaDrawData;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  },
  components: {
    crumbs,
    withdrawDialog,
    previewPrepaid
  },
  methods: {
    // 获取媒体运营数据
    initData() {
      getSourceOperatorUserList().then(res => {
        this.SourceOperatorUserList = Object.assign(
          {},
          this.SourceOperatorUserList,
          res.list
        );
      });
      getSourceUserList().then(res => {
        this.SourceUserList = Object.assign({}, this.SourceUserList, res.list);
      });
    },
    UserIdChange() {
      var that = this;
      if (this.searchData.userId === "") {
        setTimeout(function() {
          that.$refs["searchForm"].clearValidate();
        }, 500);
      }
    },
    // 获取媒体提现申请数据
    getMediaWithdraw(type) {
      if (type) {
        this.currentPage = 1;
      }

      var filterData = {
        pageIndex: this.currentPage,
        pageSize: 20,
        userId: this.searchData.userId,
        companyName: this.searchData.companyName,
        sourceOperatorId: this.searchData.sourceOperatorId,
        SourcemanId: this.searchData.SourcemanId,
        status: this.searchData.status - 0,
        BeginDate: this.searchData.applyTime
          ? this.searchData.applyTime[0]
          : "",
        EndDate: this.searchData.applyTime ? this.searchData.applyTime[1] : "",
        BeginUpdateDate: this.searchData.operateTime
          ? this.searchData.operateTime[0]
          : "",
        EndUpdateDate: this.searchData.operateTime
          ? this.searchData.operateTime[1]
          : ""
      };
      this.$nextTick(() => {
        this.$refs["searchForm"].validate(valid => {
          if (valid) {
            getMediaDrawPageList(filterData)
              .then(res => {
                if (res.list) {
                  this.tableData = res.list;
                  this.dataSize = res.count;
                  this.totalPretaxAmount = res.totalPretaxAmount;
                  this.totalAftertaxAmount = res.totalAftertaxAmount;
                  this.totalInvoiceAmount = res.totalInvoiceAmount;
                } else {
                  this.tableData = [];
                  this.dataSize = 0;
                  this.totalPretaxAmount = 0;
                  this.totalAftertaxAmount = 0;
                  this.totalInvoiceAmount = 0;
                }
              })
              .catch(err => {
                this.tableData = [];
                this.dataSize = 0;
                this.totalPretaxAmount = 0;
                this.totalAftertaxAmount = 0;
                this.totalInvoiceAmount = 0;
              });
          } else {
            return false;
          }
        });
      });
    },
    // 跳转发票操作
    jumpBill(data, type) {
      if (type === 1) {
        this.$router.push({
          name: "afterInvoiceDetailsAdd",
          params: { id: data.BusinessId, status: 1 }
        });
      } else if (type === 0) {
        var status = 0;
        if (data.Status === 1) {
          status = 1;
        } else if (data.Status > 1 && this.Review > data.Status) {
          status = 2;
        } else {
          status = 3;
        }
        this.$router.push({
          name: "afterInvoiceDetailsReview",
          params: { id: data.BusinessId, status: status }
        });
      } else {
        this.$router.push({
          name: "withdrawDetail",
          params: { id: data.BusinessId }
        });
      }
    },
    // 关闭通过和驳回的弹框
    closeDialog() {
      this.isShowDiaLog = false;
    },
    // 导入预览信息
    previewImportData(e) {
      var that = this;
      var f = e.target.files[0];
      if (f) {
        var reader = new FileReader();
        reader.onload = function(e) {
          var data = e.target.result;
          var wb = XLSX.read(data, {
            type: "binary"
          });
          var jsonData = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);
          jsonData.forEach(ele => {
            ele["起始日期"] = new Date(1900, 0, ele["起始日期"] - 1).Format(
              "yyyy-MM-dd"
            );
          });
          if (jsonData.length > 100) {
            that.$alert("导入数据条数不能超过100条", "警告", {
              type: "warning",
              center: true
            });
            that.$refs.uploadFile.value = "";
          } else {
            that.isShowPreview = true;
            that.dialogPragram.tableData = jsonData;
          }
        };
        reader.readAsBinaryString(f);
      }
    },
    // 关闭预览
    closePreview(data) {
      var uploadDataTemplate = {
        UserId: "媒体商ID",
        PretaxAmount: "结算金额",
        AftertaxAmount: "税后金额",
        BankUserName: "打款账户",
        BankAccount: "打款账号",
        BranchBankInfo: "支行信息",
        Remark: "备注",
        SettlementDate: "起始日期",
        InvoiceAmount: "发票金额",
        MediaName: "媒体商名称",
        CompanyName: "公司名称",
        SourceOperator: "媒体运营",
        Medium: "媒介",
        ContractCompany: "合同公司"
      };

      if (data) {
        var uploadInfo = this.formatUploadData(data, uploadDataTemplate);
        ImportMediaDrawData(uploadInfo)
          .then(res => {
            this.isShowPreview = false;
            this.getMediaWithdraw();
            this.$refs.uploadFile.value = "";
          })
          .catch(code => {
            this.isShowPreview = false;
            this.$refs.uploadFile.value = "";
          });
      } else {
        this.isShowPreview = false;
        this.$refs.uploadFile.value = "";
      }
    },
    //格式化上传数据
    formatUploadData(data, uploadDataTemplate) {
      var uploadData = [];
      data.forEach(function(ele) {
        var tempObj = {};
        for (var key in ele) {
          for (var key2 in uploadDataTemplate) {
            if (key === uploadDataTemplate[key2]) {
              tempObj[key2] = ele[key];
            }
          }
        }
        uploadData.push(tempObj);
      });
      return uploadData;
    },
    // 格式化时间
    formatDater(row, column, cellValue, index) {
      return formatDateAll(cellValue);
    },
    // 格式税后金额
    formatAftertaxAmount(row, column, cellValue, index) {
      if (row.PretaxAmount === cellValue) {
        return "--";
      } else {
        return cellValue;
      }
    },
    // 通过结算信息
    resolveCheck(row) {
      this.dialogPragram.title = "通过结算申请";
      this.dialogPragram.info = row;
      this.dialogPragram.remark = false;
      this.dialogPragram.type = "通过";
      this.isShowDiaLog = true;
      this.dialogPragram.callback = this.reviewMediaDraw;
    },
    // 驳回结算信息
    rejectCheck(row) {
      this.dialogPragram.info = row;
      this.dialogPragram.title = "驳回结算申请";
      this.dialogPragram.remark = true;
      this.dialogPragram.type = "驳回";
      this.isShowDiaLog = true;
      this.dialogPragram.callback = this.reviewMediaDraw;
    },
    // 通过/驳回结算信息接口调用
    reviewMediaDraw(data) {
      var step;
      if (this.Review === 2) {
        step = "UnderReviewMediaDraw";
      } else if (this.Review === 3) {
        step = "InvoicingReviewMediaDraw";
      } else if (this.Review === 4) {
        step = "PayReviewMediaDraw";
      } else {
        step = "UnderReview";
      }

      ReviewMediaDraw(data, step).then(res => {
        this.getMediaWithdraw();
        this.isShowDiaLog = false;
      });
    },
    showImage() {
      this.imageUrl = "../../common/img/b_img.png";
      this.IsShowImage = true;
    },
    // 分页切换页码
    pageChange(currentPage) {
      this.currentPage = currentPage;
      this.getMediaWithdraw();
    },
    //全选多选操作
    handleSelectionChange(val) {
      this.batchData = val;
    },
    //打开确定批量操作弹框
    confirmBatch() {
      this.dialogPragram.title = "提示";
      this.dialogPragram.type = "通过";
      this.isShowDiaLog = true;
      this.dialogPragram.callback = this.btchReviewMediaDraw;
    },
    // 批量通过
    btchReviewMediaDraw() {
      var BusinessIds = [];
      this.batchData.forEach(function(item) {
        BusinessIds.push(item["BusinessId"]);
      });
      var sendData = {
        BusinessIds: BusinessIds,
        Status: this.batchData[0].Status + 1,
        Remark: ""
      };
      var step;
      if (this.Review === 2) {
        step = "BatchUnderReviewMediaDraw";
      } else if (this.Review === 3) {
        step = "BatchInvoicingReviewMediaDraw";
      } else if (this.Review === 4) {
        step = "BatchPayReviewMediaDraw";
      } else {
        step = "BatchUnderReviewMediaDraw";
      }
      BatchReviewMediaDraw(sendData, step).then(res => {
        this.isShowDiaLog = false;
        this.getMediaWithdraw();
      });
    },
    // 批量是否可选
    selectable(row) {
      if (this.Review > row.Status) {
        if (row.InvoiceAmount > 0) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  },
  created() {
    document.title = "媒体商提现审核";
    this.initData();
    this.getMediaWithdraw();
  },
  mounted() {},
  beforeRouteLeave(to, from, next) {
    if (
      to.name === "withdrawDetail" ||
      to.name === "afterInvoiceDetailsAdd" ||
      to.name === "afterInvoiceDetailsReview"
    ) {
      if (!from.meta.keepAlive) {
        from.meta.keepAlive = true;
      }
      next();
    } else {
      from.meta.keepAlive = false;
      to.meta.keepAlive = false;
      this.$destroy();
      next();
    }
  },
  activated() {
    this.getMediaWithdraw();
  }
};
</script>
<style>
.navbar {
  min-height: none;
  max-height: 50px;
}
ul.nav {
  padding: 0 !important;
}
#navbar .sign-in-wrap {
  padding-right: 50px !important;
}
.launchTime .el-date-editor .el-range-separator {
  width: 10% !important;
}
#edui1_iframeholder {
  max-height: 177px !important;
  overflow: auto !important;
}
.money-icon {
  margin-right: 5px !important;
}
.areaWindow .el-dialog {
  width: 940px !important;
  margin-top: 4vh !important;
}
.areaWindow .el-dialog__body {
  padding: 8px 32px 75px !important;
}
.putonArea .region {
  margin-top: 4px !important;
}
.putonArea .region .provinces-group {
  width: 650px !important;
}
.putonArea .region .provinces-group .provinces {
  border: 1px solid transparent;
}
.putonArea .region .provinces-group .provinces .cities-group {
  max-height: 150px !important;
  font-size: 14px !important;
  border: 1px solid #ccc !important;
  border-left: none !important;
}
.putonArea .region .provinces-group .provinces.mouseon .cities-group .cities {
  border-right: none !important;
  border-bottom: none !important;
}
.el-select-dropdown__wrap {
  margin-right: -71px !important;
}
</style>
<style lang="scss">
@import "../../common/scss/color.scss";
.withdraw-checking {
  .filter-search {
    border: 1px solid #f2f2f2;
    padding: 20px 15px;
    // .el-input {
    //   width: 140px;
    // }
    .el-select {
      .el-input {
        width: 130px;
      }
    }
    .el-date-editor {
      width: 250px;
    }
    .el-button {
      min-width: 94px;
    }
    .export-button {
      width: 94px;
      display: inline-block;
      color: #fff;
      background-color: #5798d7;
      line-height: 1;
      white-space: nowrap;
      cursor: pointer;
      border: 1px solid #5798d7;
      text-align: center;
      box-sizing: border-box;
      outline: 0;
      margin-left: 10px;
      padding: 9px 15px;
      font-size: 12px;
      border-radius: 4px;
      &:hover {
        background: #66b1ff;
        border-color: #66b1ff;
        color: #fff;
      }
    }
    .import-button {
      margin-left: 10px;
      display: inline-block;
      position: relative;
      .import-file {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
      }
    }
  }
  .sum-type {
    span {
      display: inline-block;
      width: 200px;
      height: 50px;
      line-height: 50px;
      text-align: center;
      margin: 10px;
      border: 1px solid #bbb;
      border-radius: 12px;
    }
  }
  .data-type {
    padding: 15px;
    .data-size {
      color: #bbbbbb;
      font-size: 14px;
    }
    .el-icon-menu:before {
      font-size: 18px;
      vertical-align: middle;
    }
  }
  .data-list {
    .el-button {
      margin: 0;
      width: 100%;
      font-size: 14px;
    }
    thead {
      tr {
        background-color: #f5f5f5 !important;
        border-bottom: 2px solid #bbb;
        text-align: center;
      }
    }
    .el-pagination {
      text-align: center;
      margin: 30px 0;
    }
  }
  .image-content {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    background-color: #000;
    .close-image-modal {
      display: inline-block;
      width: 20px;
      height: 20px;
      position: absolute;
      top: -5px;
      right: -5px;
      font-size: 28px;
      color: #e5e5e5;
      background-color: #fff;
      line-height: 15px;
      border-radius: 10px;
      cursor: pointer;
    }
    img {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/financial-management/withdraw-checking.vue